import { DSStatus, alphabeticalCompare } from '@cims-online/shared'
import WorkflowRollbackModal from 'components/CIMSModal/WorkflowRollbackModal'
import { useDesignSubmittalLogContext } from '../../../../DesignSubmittalLogContext'
import { RouterReview } from '../AdvancementModal/RouterReview'
import { useRevertDesignSubmittalMutation } from 'schema'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRevertNotification } from 'hooks/notificationHandler'
import { RouterReviewValues } from '../AdvancementModal/RouterReview/types'
import { errorHandler } from 'hooks/errorHandler'
import { dateFormatter } from 'utils/dateFormatter'

const RevertModal: React.FC = () => {
  const {
    refetch,
    revertModal: { visible, toggle, state },
  } = useDesignSubmittalLogContext()
  const [revert, { loading: reverting }] = useRevertDesignSubmittalMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      revertDesignSubmittal: {
        designSubmittal: { sharePointFolderName },
      },
    }) =>
      simpleRevertNotification({
        name: sharePointFolderName,
        status: DSStatus.DisciplineAction.name,
      }),
  })
  return (
    <WorkflowRollbackModal
      visible={visible}
      onClose={() => toggle(null)}
      loading={reverting}
      onOk={async ({
        disciplineIds,
        actionIds,
        contractDueDate,
        comment,
      }: RouterReviewValues) => {
        if (!state?.id) {
          return errorHandler('Design submittal id must be defined')
        }

        await revert({
          variables: {
            revertDesignSubmittalInput: {
              id: state?.id,
              actionIds,
              disciplineIds,
              contractDueDate: contractDueDate.toISOString(),
              comment,
            },
          },
        })
        refetch()
        toggle(null)
      }}
      endStatus={DSStatus.DisciplineAction.name}
      recordName={state?.sharePointFolderName}
      affectedItems={[
        {
          label: 'Disposition',
          value: state?.disposition,
        },
        {
          label: 'Disposition Date',
          value: dateFormatter.simple(state?.dispositionDate),
        },
        {
          label: 'Disposition By',
          value:
            state?.dispositionBy?.displayName ?? state?.dispositionBy?.mail,
        },
        {
          label: 'Disciplines',
          value: (state?.dsToDSDisciplines ?? [])
            .sort((a, b) =>
              alphabeticalCompare(a.discipline.name, b.discipline.name)
            )
            .map(({ discipline, accepted, acceptedBy, acceptedDate }) => ({
              label: discipline.name,
              value: [
                {
                  label: 'Accepted',
                  value: accepted.toString(),
                },
                {
                  label: 'Accepted By',
                  value: acceptedBy?.displayName ?? acceptedBy?.mail,
                },
                {
                  label: 'Accepted Date',
                  value: dateFormatter.simple(acceptedDate),
                },
              ],
            })),
        },
      ]}
      formItems={<RouterReview />}
    />
  )
}

export default RevertModal
